// @flow

import { createBrowserHistory } from 'history';

const createHistory = createBrowserHistory();

createHistory.listen(() => {
  window.scrollTo(0, 0);
});

export default createHistory;
